import { Button, Collapse, Modal, notification, Row, Select, Tabs, Tag, Tooltip } from "antd";
import { CallServices, CoreServices, EmailServices } from "../../../../base/service/apiServices";
import { getParticularAgentuser, hassAccess, insertUpdateAgentAssist, isJSON, navigateToTicketing } from "../../../../base/utils";
import React, { Fragment, useEffect, useRef, useState } from "react"

import { AntInput } from "../../../../shared/widges/antinput";
import { ChatActions } from "../../../../store/slices/chat_slice/chat_slice";
import { ChatState } from "../../../../base/models/model";
import { GetAlluserActions } from "../../../../store/slices/user_management/get_all_users";
import { GetItemFromStorage } from "../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../custom_hooks/localStorageKeys";
import NoDataFound from "../../../nodatafound/nodatafound";
import Locts from '../../../../styles/images/firstsec.svg';
import Loctstsfirst from '../../../../styles/images/secondsec.svg';
import Loctsts from '../../../../styles/images/thirdsec.svg';
import _, { keys } from "lodash";
import { access } from "fs";
import axios from "axios";
import callChatService from "../../../../base/service/chatService";
import { cochatActions } from "../../../../store/slices/cochat_slice/cochat_channels_slice";
import { CHAT_BOX_PLAN_ID, config, CONTACT_CENTRE_PLAN_ID, ROLES } from "../../../../base/constant";
import { getAllUsers } from "../../../../store/api/user_management";
import { internalChatActions } from "../../../../store/slices/chat_slice/internalChat_slice";
import jwt_decode from "jwt-decode";
import Upgradepass from '../../../../styles/images/Premium.svg'
import moment from "moment";
import styles from "./chatRightSidebar.module.scss";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { useSelector } from "react-redux";
import { userList } from "../../../../constants/interface/users";
import { v4 as uuidv4 } from "uuid";
import { WtButton } from "../../../../shared/widges/Button/button";
import InternalChat from "./internalChat";
import InternalchatArea from "./chatArea";
import InteractionInfo from "./interactionInfo";
import { useNavigate } from "react-router-dom";
import Loaders from "../../../loader/loader";
import sendicon from '../../../../styles/images/sendiconchat.svg';
import { getCoChatChannelsDetails } from "../../../../store/api/cochat";
import { useMediaQuery } from "react-responsive";
import parse from "html-react-parser";
import Editor from "../../../chatRightBar/editor/chatbottom";
import Editornew from "../../../cochat/broadcast/chatEditor/chatbottomnew";
import Editornotes from "../../../editornotes/editornotes";
import notesemptyimg from "../../../../../src/styles/images/notesEmpty.svg"
import Aiupgrade from "../../../../shared/widges/upgrademodal/aiupgrade";
import { UserSettingsActions } from "../../../../store/slices/settings_slice/user_settings_slice";
const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);





const { Option } = Select;
const { Panel } = Collapse;
const ChatRightSideBar = () => {
  // let cookieData: any = Cookie.get();
  const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
  const productId = GetItemFromStorage(LocalStorage.PRODUCT_ID);
  const login_details: any = GetItemFromStorage(LocalStorage.USER_DETAILS);
  const companyId: number = isJSON(login_details) ? JSON.parse(login_details)?.companyId : login_details?.companyId
  // console.log('login_details>>>>>>>>>',companyId,productId)
  let LoginUserDetails: any = accessToken && jwt_decode(accessToken);
  const [chatVisible, setChatVisible] = useState(false);
  const [isTag, setIsTag] = useState(false);
  const [isExpand, setExpand] = useState(true);
  const [agentQueryText, setAgentQueryText] = useState('');
  const [isAssExpand, setAssExpand] = useState(false);
  const [apiData, setApiData] = useState<any>([]);
  const [agentList, setAgentList] = useState<any>([]);
  const [apiResponse, setApiResponse] = useState<any>([]);
  const userListData: userList = useSelector((state: any) => state.userList);
  const allContactList: any = useSelector((state: any) => state.contactListForAgent.allContactList);
  const agentUserList: any = useSelector((state: any) => state.userList);
  const { activeChannel } = useSelector((state: any) => state.coChat);
  const loginProductDetail = GetItemFromStorage(LocalStorage.PRODUCT_ID);
  const loginPlanDetail = GetItemFromStorage(LocalStorage.PLAN_ID);
  const [scriptInfo, setScriptInfo] = useState('');
  const { users, isVisibleAgent, selectedAgent } = agentUserList;
  const [expandData, setexpandData] = useState<any>({});
  const [agentallList, setAgentallList] = useState<any>([]);
  const [userallList, setUserallList] = useState<any>([]);
  const [isTab, setIsTab] = useState('agentassist');
  const [loading, setLoading] = useState<any>(false);
  const [divHeight, setDivHeight] = useState(0);
  const navigate = useNavigate();
  let viewTitle = loginPlanDetail === 54 || loginPlanDetail === 32 || loginPlanDetail === 116 || loginPlanDetail === 76 || loginPlanDetail === 126 || loginPlanDetail === 132 ? "Smart Reply" : "Agent Assist"
  // const { internalchatmessage }: any = useSelector((state: any) => state.coChat);
  const { internalchatmessage, agentAssitence, currentSession, currentSessionMsgHistory, agentAssist, agentAssistRelaod, agent_work_space_history, internalAssist, assistPayload }: any = useSelector((state: any) => state.chatReducer);
  const roomData: any = useSelector((state: any) => state.chatReducer);
  const { internalChatDetails } = useSelector((state: any) => state.internalChatDetails);
  const { supervisorWhisperStatus } = useSelector((state: any) => state.chatReducer);
  const { isChatDisPositionStatus }: any = useSelector((state: any) => state.dispositionData);
  const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
  const roleId = GetItemFromStorage(LocalStorage.ROLE_ID);
  // let currentSessionStatus = currentSession.sessionStatus;
  // console.log("expandData", expandData)
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const messagesEndRef_agentAssist = useRef<HTMLDivElement>(null);
  const [currentAgentAssist, setCurrentAgentAssist] = useState([])
  const isMobile = useMediaQuery({ maxWidth: 1024 });
  const notes = useSelector((state: any) => state.chatReducer.currentSession.notes); // Accessing notes from Redux
  const [editingMessageId, setEditingMessageId] = useState(null);
  const [editorContentmsg, setEditorContentmsg] = useState<string>('');
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  let { isTrackAgent } = popUpDetails;
  const isTrackerAgentChat = ['view', 'whisper', 'barge'].includes(supervisorWhisperStatus);
  const agentAssistTextareaRef = useRef<HTMLTextAreaElement | null>(null);
  // console.log("isTrackerAgentChat", isTrackerAgentChat, supervisorWhisperStatus)
  const divRef = useRef<HTMLDivElement | null>(null);
  const planId: any = GetItemFromStorage(LocalStorage.PLAN_ID);
  const [openUpgradeModel, setOpenUpgrade] = useState({
    open: false,
    content: ''
  })

  useEffect(() => {
    messagesEndRef?.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "end" });
  }, [internalChatDetails, isMobile]);

  

  useEffect(() => {
    setEditingMessageId(null);
    setEditorContentmsg('');
    setIsExpanded(false)
  }, [currentSession?.sessionId])


  useEffect(() => {
    messagesEndRef_agentAssist?.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "end" });
    if (!currentSession?.isChatEnded && !isChatDisPositionStatus) {
      setCurrentAgentAssist(agentAssist)
    }
  }, [agentAssist?.length, agentallList?.length, isMobile]);

  useEffect(() => {
    let resData: any = _.filter(agentAssitence, (item: any) => {
      return item.ChatHistoryId ? item.ChatHistoryId?.toString() === currentSession?.ChatHistoryId?.toString() : item.sessionId?.toString() === currentSession?.sessionId?.toString();
    });
    if (!currentSession?.isChatEnded && !isChatDisPositionStatus) {
      setAgentallList(resData);

    }
    setUserallList(users);
  }, [agentAssitence, currentSession])

  const dispatch = useDispatcher();
  const showInternalChat = () => {
    setChatVisible(!chatVisible);
  };
  const showContact = () => {
    dispatch(GetAlluserActions.setVisible(!isVisibleAgent));
    //setAddAgent(addAgent)
  };
  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      sendInternalChatMessage();
    }
  };
  const getAgentList = (e: any) => {
    if (e.target.value !== "") {
      CoreServices.get(`/get_all_user_list?name=${e.target.value}`).then((value) => {
        setAgentList(value.data.getAllUserList);
      });
    } else {
      setAgentList(allContactList);
    }
  };
  useEffect(() => {
    dispatch(getCoChatChannelsDetails(activeChannel ?? ""));
    callChatService?.io?.emit("joinCoChat", {
      channelId: activeChannel ?? "",
      ipAddress: LoginUserDetails?.ipaddress ?? "",
    });
    callChatService?.io?.emit("seenStatus", { status: true, userId: LoginUserDetails, channelId: internalChatDetails?.channelId });
  }, []);
  const domainIds: any = [];
  selectedAgent.forEach((data: any) => {
    domainIds.push(data?.domainId);
  });
  const extension: any = [];
  selectedAgent.forEach((data: any) => {
    extension.push(data?.ext);
  });

  const sendInternalChatMessage = () => {
    let currentMessage = {
      messageId: uuidv4(),
      seenBy: [],
      message: internalchatmessage,
      sender: { uuid: LoginUserDetails?.uuid, name: LoginUserDetails?.profileName, emailId: LoginUserDetails?.username },
      sentAt: Date.now(),
      domainId: domainIds,
      ext: extension,

      // domainId: JSON.parse(cookieData.userDetials).domain_id,
      // ext:JSON.parse(cookieData.userDetials).ext
    };

    callChatService.io.emit("sendMessageToCoChat", currentMessage);
    dispatch(internalChatActions.internalChatsendMessage({ internalchatmessage: currentMessage }));

    // dispatch(ChatActions.updateInternalMessage(""));
    // dispatch(cochatDetailsActions.sendMessage({ message: currentMessage }));
    dispatch(ChatActions.updateInternalMessage(""));
    dispatch(GetAlluserActions.setVisible(false));
  };
  const selectednewAgent = (e: any) => {
    dispatch(GetAlluserActions.selectedAgent(e));
    setIsTag(true);
  };
  const remove = (e: any) => {
    dispatch(GetAlluserActions.removeAgent(e));
  };
  useEffect(() => {
    dispatch(ChatActions.chatAgentAssistListFilter(currentSession?.sessionId));
    // getData();
    // if ((currentSession?.channelType === 'Sms') && currentSession?.IsSessionClosed !== 1)
    //  getAgentAssitData('')
  }, []);

  useEffect(() => {
    dispatch(getAllUsers());
  }, [dispatch]);
  // const token: any = Cookie.get();
  var totalVal: any;
  const mapFunction = () => {
    totalVal.map((values: any, index: any) => {
      let momentdate: any = moment(values.sessionStartTime * 1000).format("DD-MM-YYYY");

      const yesterday = moment().subtract(1, "day").format("DD-MM-YYYY");
      const today = moment().format("DD-MM-YYYY");

      if (momentdate === today) {
        totalVal[index].day = "Today";
      } else if (momentdate === yesterday) {
        totalVal[index].day = "Yesterday";
      } else {
        totalVal[index].day = momentdate;
      }
    });

    const groups = totalVal.reduce((groups: any, game: any) => {
      const date = game.day;
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(game);
      return groups;
    }, {});

    // Edit: to add it in the array format instead
    const groupArrays = Object.keys(groups).map((date) => {
      return {
        date,
        interactionsData: groups[date],
      };
    });

    groupArrays.map((item: any) => {
      item.interactionsData.map((data: any) => {
        let valueData = getParticularAgentuser(userListData.users, data?.agentDetails);
        data.agentDetailcomplete = valueData[0];
      });
    });

    setApiData(groupArrays);
  };
  const getData = () => {
    let chatBynumberData = { number: "441143200044" };
    // let chatBynumberData = { number: chatReducer?.currentSession?.customerDetails }
    // if (chatReducer?.currentSession?.customerDetails) {
    CallServices.post(chatBynumberData, "/get_chatByNumber").then((resp: any) => {
      totalVal = resp.data.result;
      mapFunction();
    });
    // }
  };
  const getConversationList = () => {
    dispatch(internalChatActions.showModal);
    axios.get(`${config().BASE_URL}/callservice/v1/get_sessionid_list/${apiData?.interactionsData?.sessionId}`).then((value: any) => {
      setApiResponse(value);
    });
  };
  const copyClipboard = (data: any, ref: any) => {
    const innerText: any = document.getElementById(ref)?.innerText
    const html = data.replace(/<[^>]*>/g, '').trim()
    console.log('html', html)
    navigator.clipboard.writeText(data);
    notification.info({
      message: `Copied dddd!`,
      placement: "topRight",
      className: "toastNotification success successnotifi",
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
      </svg>,
      closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
        <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
      </svg>,
      duration: 3,
      top: 70,
    });
  }
  const handleExpand = (data: any) => {
    setAssExpand(true);
    setexpandData(data);
  }
  const goBack = () => {
    setAssExpand(false);
  }
  const copyForward = (data: any, messageId: any) => {
    if (isSmallScreen) {
      dispatch(ChatActions.setInternalAssist(false));
    }
    const textClr: any = document.getElementById('textedited');
    textClr.innerHTML = data;
    dispatch(ChatActions.setEditState(true));
    setAssExpand(false);

    const assistData = {
      AssistMsg: {
        assistMsg: data,
        isLike: 0,
        isDislike: 0,
        isUsed: 1,
        messageId: messageId
      },
      NoOfUsedAssistMsg: 1,
      totalNoOfassist: 0,
      isUpdate: 1
    }
    insertUpdateAgentAssist(assistData);
  }
  const handleTabChange = (key: any) => {
    // if (key === 'Notes' && !hassAccess('workspace/notes')) {
    //   dispatch(UserSettingsActions.setUpgradePlan(true))
    //   return
    // }
    setIsTab(key);
  };
  const handleSearch = (e: any) => {
    let value: any = e.target.value;
    let result: any = _.filter(users, function (data: any) {
      return data?.UserName?.toLowerCase().includes(value);
    });
    setUserallList(result);
  }

  const getAgentAssitData = (regenerate: any) => {
    try {
      if (currentSession?.ChatHistoryId && regenerate !== '') {
        const message: any = []
        const sessionMsg = currentSessionMsgHistory;
        if (Array.isArray(sessionMsg)) {
          for (let msg of sessionMsg) {
            if (msg?.isCustomer && !msg?.isBot) {
              const userMessage = msg?.message
              message.push({ userText: userMessage })
            } else if (!msg?.isCustomer && !msg?.isBot) {
              const agentMessage = msg?.message
              message.push({ agentText: agentMessage })
            }
          }
        }
        if (agentAssitence?.length > 0 && regenerate !== '') {
          const assistMsg = agentAssitence.filter((row: any) => row?.messageId === expandData?.messageId)
          if (assistMsg.length > 0) {
            message.push({ botText: assistMsg[0]?.message ? assistMsg[0]?.message : assistMsg[0]?.response })
          }
        }
        const body = {
          channelType: "Chat",
          channelId: currentSession?.ChatHistoryId?.toString(),
          message,
          sessionId: currentSession?.sessionId,
          type: regenerate,
          customerId: ''
        }
        if (body?.message?.length > 0) {
          try {
            EmailServices.post(body, '/get_agent_assist_info').then((response) => {
              if (response && response.data.statusCode === 200) {
                setAssExpand(false);
                dispatch(ChatActions.chatAgentAssistReload(false))
              }
            }).catch((error) => console.log('11dd11', error))
          } catch (error) {
            console.log(error)
          }
        }
      } else if (currentSession?.CallHistoryId && regenerate !== '') {
        const message: any = []
        const sessionMsg = currentSessionMsgHistory;
        if (Array.isArray(sessionMsg)) {
          for (let msg of sessionMsg) {
            if (msg?.isCustomer && !msg?.isBot) {
              const userMessage = msg?.message
              message.push({ userText: userMessage })
            } else if (!msg?.isCustomer && !msg?.isBot) {
              const agentMessage = msg?.message
              message.push({ agentText: agentMessage })
            }
          }
        }
        if (agentAssitence?.length > 0 && regenerate !== '') {
          // const assistMsg = agentAssitence.filter((row: any) => row?.messageId === expandData?.messageId)
          // if (assistMsg.length > 0) {
          //   message.push({ botText: assistMsg[0]?.message ? assistMsg[0]?.message : assistMsg[0]?.response })
          // }
          if (expandData) {
            message.push({ botText: expandData?.message ? expandData?.message : expandData?.response })
          }
        }
        const body = {
          channelType: "Call",
          channelId: currentSession?.CallHistoryId.toString(),
          message,
          sessionId: currentSession?.sessionId,
          type: regenerate,
          customerId:''
        }
        if (body?.message?.length > 0) {
          try {
            EmailServices.post(body, '/get_agent_assist_info').then((response) => {
              if (response && response.data.statusCode === 200) {
                setAssExpand(false);
                dispatch(ChatActions.chatAgentAssistReload(false))
              }
            }).catch((error) => console.log('11dd11', error))
          } catch (error) {
            console.log(error)
          }
        }
      } else {
        let channelId = ''
        if (currentSession?.channelType === 'Email')
          channelId = currentSession?.ToEmail
        else if (currentSession?.channelType === 'Sms' || currentSession?.channelType === 'Whatsapp')
          channelId = currentSession?.calledNumber
        else if (currentSession?.channelType === 'Facebook')
          channelId = currentSession?.agentFacebookId
        else if (currentSession?.channelType === 'Instagram')
          channelId = currentSession?.agentInstagramId

        let customerId = '';
        if (currentSession?.channelType === 'Email')
          customerId = currentSession?.FromEmail
        else if (currentSession?.channelType === 'Sms' || currentSession?.channelType === 'Whatsapp')
          customerId = currentSession?.customerNumber
        else if (currentSession?.channelType === 'Facebook')
          customerId = currentSession?.customerFacebookId
        else if (currentSession?.channelType === 'Instagram')
          customerId = currentSession?.customerInstagramId

        if (channelId === '')
          return;

        const message: any = []
        const sessionMsg = JSON.parse(currentSession?.Message)
        if (Array.isArray(sessionMsg)) {
          for (let msg of sessionMsg) {
            if (msg?.userText) {
              const userMessage = msg?.userText?.message?.message?.trim()?.replace(/<div>/g, '').replace(/<\/div>|<br>/g, '\n').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ')

              message.push({ userText: userMessage })
            } else {
              const agentMessage = msg?.agentText?.message?.message?.trim()?.replace(/<div>/g, '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ')
              message.push({ agentText: agentMessage })
            }
          }
        } else {
          const userMessage = sessionMsg?.userText?.message?.message?.trim()?.replace(/<div>/g, '').replace(/<\/div>|<br>/g, '\n').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ')
          if (userMessage)
            message.push({ userText: userMessage })
        }

        if (agentAssitence?.length > 0 && regenerate !== '') {
          const assistMsg = agentAssitence.filter((row: any) => row?.messageId === expandData?.messageId)
          if (assistMsg.length > 0) {
            message.push({ botText: assistMsg[0]?.message })
          }
        }
        const body = {
          channelType: currentSession?.channelType,
          channelId: channelId?.toString(),
          message,
          sessionId: currentSession?.sessionId,
          type: regenerate,
          customerId : customerId ?? ''
        }
        if (body?.message?.length > 0) {
          try {
            EmailServices.post(body, '/get_agent_assist_info').then((response) => {
              if (response && response.data.statusCode === 200) {
                setAssExpand(false);
                dispatch(ChatActions.chatAgentAssistReload(false))
                dispatch(ChatActions.setAssistPayload({}));
              }
            }).catch((error) => console.log('11dd11', error))
          } catch (error) {
            console.log(error)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }


  // useEffect(() => {
  //   if (agentAssistRelaod && currentSession?.IsSessionClosed !== 1) {
  //     dispatch(ChatActions.chatAgentAssistReload(false))
  //     getAgentAssitData('')
  //   }
  // }, [agentAssistRelaod])


  const interactionDetails = (data: any) => {
    try {
      const channelHistoryKeys = [
        "ChatHistoryId",
        "EmailHistoryId",
        "WhatsappHistoryId",
        "SMSHistoryId",
        "FacebookHistoryId",
        "InstagramHistoryId",
        "CallHistoryId"
      ];

      const found: any = channelHistoryKeys.find(key => data?.[key]);
      setLoading(true);
      let body: any = {
        customerId: data?.customerId,
        interactionId: data[found],
        TicketId: data?.ticketId

      };
      let customerDetails = [] as any;
      CoreServices.get(`/get_customer_conatct_details/${data?.customerId}`).then((response) => {
        if (response && response.data.statusCode === 200 && response?.data?.getContactDetailsRes?.length > 0) {
          customerDetails = response?.data?.getContactDetailsRes
        }
      }).catch((error) => console.log('11dd11', error))


      CoreServices.post(body, `/get_interaction_details_view`)
        .then((response: any) => {
          if (response && response.data.statusCode === 200) {
            let response_data: any = [...response.data.getInteractionViewResponse];
            let chatSessionData: any = {}
            chatSessionData.sessionId = uuidv4()
            chatSessionData.scrollId = currentSession?.ChatDurationHistoryId;
            chatSessionData.calledPersonDetails = { ...currentSession?.calledPersonDetails, firstName: customerDetails[0]?.firstName, lastName: customerDetails[0]?.lastName }
            chatSessionData.isInteractionView = true
            chatSessionData.interactionData = response_data
            dispatch(ChatActions.setinteractionData(response_data));
            dispatch(ChatActions.chatSessionList(chatSessionData));
            dispatch(ChatActions.currentChatSession(chatSessionData));
            navigate("/chatscreenagent");
          }
        })
        .catch((err) => {
          console.log(err);
          notification.info({
            message: "network error",
            placement: "topRight",
            className: "toastNotification error",
            icon: <span className="icon__Error24" />,
            closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
            </svg>,
            duration: 3,
            top: 70,
          });
        }).finally(() => {
          setLoading(false)
        })
    } catch (error) {
      console.log(error);
    }

  }

  const handleLike = (data: any,) => {

    const isLike = data?.AssistMsg?.isLike === 1 ? 0 : 1;
    const isDislike = 0;
    const isUsed = 0;
    const isUpdated = isLike !== 1 || isDislike !== 0 || isUsed !== 0 ? true : false;

    const likedata = {
      AssistMsg: {
        assistMsg: data.response,
        isLike: isLike,
        isDislike: isDislike,
        isUsed: isUsed,
        messageId: data.messageId,

      },
      // AssistMsg: { assistMsg: data,isLike: 1,isDislike: 1,isUsed:0},
      NoOfUsedAssistMsg: 0,
      totalNoOfassist: 0,
      isUpdate: isUpdated
    }

    dispatch(ChatActions.agaentLikeAssitence(likedata));
    insertUpdateAgentAssist(likedata)
  }
  const handledisLike = (data: any) => {

    const isLike = 0;
    const isDislike = data?.AssistMsg?.isDislike === 1 ? 0 : 1;
    const isUsed = 0;
    const isUpdated = isLike !== 0 || isDislike !== 1 || isUsed !== 0 ? true : false;

    const dislikedata = {
      AssistMsg: {
        assistMsg: data.response,
        isLike: isLike,
        isDislike: isDislike,
        isUsed: isUsed,
        messageId: data.messageId,

      },
      // AssistMsg: { assistMsg: data,isLike: 1,isDislike: 1,isUsed:0},
      NoOfUsedAssistMsg: 0,
      totalNoOfassist: 0,
      isUpdate: isUpdated
    }

    dispatch(ChatActions.agaentLikeAssitence(dislikedata));
    insertUpdateAgentAssist(dislikedata)
  }



  const handleAgentQueryAssist = () => {
    setAgentQueryText('')
    if (agentQueryText.trim()) {
      const websiteData = agent_work_space_history?.filter((list: any) => list?.sessionId === currentSession?.sessionId)
      const websiteIdData = websiteData.find((list: any) => {
        return list?.websiteId
      });
      const body = {
        user_query: agentQueryText,
        websiteId: websiteIdData?.websiteId ?? '',
        sessionId: currentSession?.sessionId ?? '',
        ChatHistoryId: currentSession?.ChatHistoryId?.toString() ?? '',
        // domainId: LoginCcaasUserDetails?.domainId,
        domainId: userDetails?.domainId ?? LoginCcaasUserDetails?.domainId ?? null,
        to: LoginCcaasUserDetails?.ext?.toString(),
        productId: productId ?? 0,
        companyId: companyId ?? 0,
        channelType:  currentSession?.channelType ? currentSession?.channelType : currentSession?.channeltype ? currentSession?.channeltype : currentSession?.ChatHistoryId ? 'Chat' : null,
      }
      axios.post([CHAT_BOX_PLAN_ID.XAIA_4_PAID, CONTACT_CENTRE_PLAN_ID['XAIA_4+']].includes(planId) ? `https://nlpccaas.worktual.co.uk/agent_search` : 'https://nlpccaas.worktual.co.uk/agent_search', body).then(async (res: any) => {
        if (res?.data?.status_code === 200) {
          res.data["timeStamp"] = new Date().getTime();
          dispatch(ChatActions.agaentAssitence(res?.data));
          const assistMsg = res?.data?.response;
          const isUpdated = assistMsg !== '' ? 1 : 0;
          const data = {
            AssistMsg: {
              assistMsg: assistMsg,
              isLike: 0,
              isDislike: 0,
              isUsed: 0
            },
            NoOfUsedAssistMsg: 0,
            totalNoOfassist: 1,
            isUpdate: isUpdated

          }
          insertUpdateAgentAssist(data);
        }
      }).catch((err: any) => { console.log("err") })
    }
  }


  const enterButton = (e: any) => {
    if (e.key === "Enter" && agentQueryText?.trim() !== "") {
      e.preventDefault();
      handleAgentQueryAssist();
    }
  };

  const [isSmallScreen, setIsSmallScreen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024) {
        setIsSmallScreen(true);
      } else {
        setIsSmallScreen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleClick = () => {
    if (isSmallScreen) {
      dispatch(ChatActions.setInternalAssist(false));
    }
  };


  const [isExpanded, setIsExpanded] = useState(false);
  const handleAddClick = () => {
    setIsExpanded(prev => !prev);
  };
  // const handleDeleteNote = (noteIdToDelete:any) => {
  //   const updatedNotes = notes.filter((note:any) => note.noteId !== noteIdToDelete);
  //   dispatch(ChatActions.setNotes(updatedNotes)); // update Redux
  // };

  const handleDeleteNote = (noteIdToDelete: any) => {
    const updatedNotes = notes.filter((note: any) => note.noteId !== noteIdToDelete);
    console.log("updatedNotes", updatedNotes)
    dispatch(ChatActions.setReplaceNotes(updatedNotes)); // or setNotes(updatedNotes) if local state
  };
  const handleEditNote = (msg: any) => {

    setEditingMessageId(msg.noteId);
    setEditorContentmsg(msg.message); // preload content into editor
  };
  // console.log("setEditorContentmsgsetEditorContentmsgsetEditorContentmsg", notes)


  useEffect(() => {
    const elem = agentAssistTextareaRef.current;
    if (elem) {
      elem.style.height = '40px'
      elem.style.height = `${elem.scrollHeight}px`
    }
  }, [agentQueryText])
  let dyHeight = `calc(154px + ${divHeight}px)`; //200px
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      // entries[0] contains the ResizeObserverEntry for our div
      const newHeight = entries[0].contentRect.height;
      setDivHeight(newHeight);
    });

    if (divRef.current) {
      resizeObserver.observe(divRef.current);
    }
    // resizeObserver.observe(divRef.current);

    // Cleanup: Disconnect the ResizeObserver when the component unmounts
    return () => {
      resizeObserver.disconnect();
    };
  }, [currentSession]);

  const containerStyle = {
    height: `calc(100vh - ${dyHeight})`,
  };
  const { TabPane } = Tabs;

  const openUpgade = (type: any) => {
    setOpenUpgrade({
      open: true,
      content: type
    })
  }
  const closeUpgade = (type: any) => {
    setOpenUpgrade({
      open: false,
      content: ""
    })
  }

   const open =()=>{
        navigateToTicketing()
    }

  return (
    <>
      {loading && <Loaders />}
      {openUpgradeModel?.open && <Aiupgrade type={openUpgradeModel.content} onOk={closeUpgade} />}
      <div className={styles.chatRightSideBar}>
        <div className="chatrightarrow">
          {/* <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none" className="chatrightarrowicon"><path d="M17.0175 6.24993H2.68844L6.73824 2.20013C7.03124 1.90713 7.03124 1.43253 6.73824 1.13963C6.44524 0.846734 5.97064 0.846634 5.67774 1.13963L1.40774 5.40913C0.978035 5.83883 0.742735 6.40863 0.745135 7.01363C0.748035 7.61323 0.984835 8.17473 1.40774 8.58983L5.67774 12.8603C5.82424 13.0068 6.01614 13.08 6.20804 13.08C6.39994 13.08 6.59184 13.0068 6.73834 12.8603C7.03134 12.5673 7.03134 12.0927 6.73834 11.7998L2.68904 7.75003H17.0176C17.4317 7.75003 17.7676 7.41413 17.7676 7.00003C17.7676 6.58593 17.4316 6.24993 17.0175 6.24993Z" fill="black"></path></svg> */}
          <Tabs defaultActiveKey="profile" activeKey={isTab} onChange={handleTabChange} className="leftSidebarTab chatscreenlefsidebar rightsiderresponsive agentchattabfix agentchattabfixtent">
            <TabPane
            tab={<span className={!hassAccess('workspace/agentAssist') ? `${styles.chatgre} ${styles.chatgrefrs}` : ''}>
                {isSmallScreen && <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none" className={styles.leftsiderespoicon} onClick={handleClick}>
                  <path d="M17.0175 6.24993H2.68844L6.73824 2.20013C7.03124 1.90713 7.03124 1.43253 6.73824 1.13963C6.44524 0.846734 5.97064 0.846634 5.67774 1.13963L1.40774 5.40913C0.978035 5.83883 0.742735 6.40863 0.745135 7.01363C0.748035 7.61323 0.984835 8.17473 1.40774 8.58983L5.67774 12.8603C5.82424 13.0068 6.01614 13.08 6.20804 13.08C6.39994 13.08 6.59184 13.0068 6.73834 12.8603C7.03134 12.5673 7.03134 12.0927 6.73834 11.7998L2.68904 7.75003H17.0176C17.4317 7.75003 17.7676 7.41413 17.7676 7.00003C17.7676 6.58593 17.4316 6.24993 17.0175 6.24993Z" fill="black" />
                </svg>} {viewTitle}</span>}
              key="agentassist"
            >
              {!hassAccess('workspace/agentAssist') ?
              <div className={styles.centerupgrade}>
                <div  className={`${styles.svgscrollert} `}>

                 {/* <div onClick={() => openUpgade('Agent Assist')} className={`${styles.svgscrollert} blurchat`}> */}
                  <div className={`${styles.agentassistu} blurchat`}>
                    <div className={styles.svgscrollertassist}>
                      <img src={Locts} />
                    </div>
                    <div className={styles.svgscrollertassist}>
                      <img src={Loctsts} />
                    </div>
                  </div>
                  <div className={`${styles.svgscrollertassistline} blurchat`}>
                    <img src={Loctstsfirst} />
                  </div>
                </div>
                 <div className={styles.upgradeline}>
                 <div className={styles.upgradetst}>Upgrade plan to view Agent assist ...</div>
                 <div className={styles.pasword}><img src={Upgradepass} alt="" />
                 {/* <button onClick={open}>Upgrade</button> */}
                 </div>
                </div>
                </div>
                :
                <div className={`scroller ${styles.chatRightMiddle} ${styles.chatRightMiddlenew} ${isTrackAgent ? styles.whenwhispercomes : ""} ${!isAssExpand ? styles.chatRightMiddleheight : ""}`}>
                  <div className={`${styles.chatRightHeader} ${styles.chatRightHeaderheight}  `}>
                    {!isAssExpand ? <>
                      {/* {customerPreviousHistory?.length > 0 &&
                      customerPreviousHistory?.map((list: any) => {
                        if (list?.sessionId === currentSession?.sessionId) {
                          return (
                            <div className={styles.interactionsummarymain}>
                              <h4 >Previous Interaction Summary</h4>
                              <div className={`${styles.interactionheader} ${styles.interactionheadernav}`}>
                                <div className={styles.headtextright}>
                                  {list?.attend?.[0] ?? 'A'}
                                </div>
                                <div className={styles.interactionheaderright}>
                                  <p className={styles.interactionname}>{list?.attend ?? 'Automatic'}</p>
                                  <p className={styles.channels}>Channel • Chat</p>
                                  <p className={styles.channels}>Last interaction • <span>{list?.time}</span></p>
                                </div>
                              </div>
                              <p>{list?.message}</p>
                              <h5 className={styles.viewinteraction} onClick={() => interactionDetails(list)}>View Interaction</h5>

                            </div>
                          )
                        }
                      })
                    } */}
                      {agentallList && agentallList?.length > 0 && agentallList?.map((list: any) => {

                        if (list?.sessionId === currentSession?.sessionId) {

                          return (
                            <>
                              <div className={`${styles.bundleenquiry} ${styles.bundleenquiryarea}`} ref={messagesEndRef_agentAssist}>
                                <div className={styles.headerArea}>
                                  <div className={styles.cardDt}>
                                    <span className={styles.title}>{list?.intent ?? ''}</span>
                                    <span className={styles.subText}>Reason • {moment(list?.timeStamp).format("hh:mm a")}</span>
                                  </div>
                                  {currentSession?.channeltype != "Call" &&
                                    <div className={styles.cardAction} >
                                      {/* <span>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M10 0C4.4772 0 0 4.4771 0 10C0 15.5229 4.4772 20 10 20C15.5228 20 20 15.5228 20 10C20 4.4772 15.5229 0 10 0ZM10 18.5C5.3131 18.5 1.5 14.687 1.5 10C1.5 5.313 5.3131 1.5 10 1.5C14.6869 1.5 18.5 5.3131 18.5 10C18.5 14.6869 14.687 18.5 10 18.5Z" fill="#757676"/>
  <path d="M13.7364 8.9517L8.874 6.1444C8.0671 5.6785 7.0583 6.2609 7.0583 7.1927V12.8073C7.0583 13.7391 8.067 14.3215 8.874 13.8556L13.7364 11.0483C14.5433 10.5824 14.5433 9.4177 13.7364 8.9517Z" fill="#757676"/></svg>
                                   </span> */}
                                      {/* <span>
                                   <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
  <path d="M9.99974 2.0033C14.6878 2.0033 18.4962 5.81175 18.4962 10.4998C18.4962 15.1879 14.6878 18.9964 9.99974 18.9964C5.31169 18.9964 1.50328 15.1779 1.50328 10.4998C1.50328 5.82174 5.31169 2.0033 9.99974 2.0033ZM9.99974 0.503906C4.47204 0.503906 0.00390625 4.97209 0.00390625 10.4998C0.00390625 16.0276 4.48204 20.4958 9.99974 20.4958C15.5174 20.4958 19.9956 16.0176 19.9956 10.4998C19.9956 4.98209 15.5174 0.503906 9.99974 0.503906Z" fill="#757676"/>
  <path d="M7.00099 7.50106V13.4886C7.00099 14.0407 7.4485 14.4882 8.00057 14.4882C8.55264 14.4882 9.00016 14.0407 9.00016 13.4886V7.50106C9.00016 6.94899 8.55264 6.50147 8.00057 6.50147C7.4485 6.50147 7.00099 6.94899 7.00099 7.50106Z" fill="#757676"/>
  <path d="M10.9993 7.50106V13.4886C10.9993 14.0407 11.4468 14.4882 11.9989 14.4882C12.551 14.4882 12.9985 14.0407 12.9985 13.4886V7.50106C12.9985 6.94899 12.551 6.50147 11.9989 6.50147C11.4468 6.50147 10.9993 6.94899 10.9993 7.50106Z" fill="#757676"/>
</svg>
                                   </span> */}
                                      {/* <span>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12.0613 5.84859L13.7313 7.56859L3.81133 17.1786L2.11133 17.1486L2.14133 15.4486L12.0613 5.83859M12.0813 3.93859C11.9513 3.93859 11.8213 3.98859 11.7313 4.07859L0.961328 14.5186C0.771328 14.7086 0.651328 14.9686 0.651328 15.2386L0.611328 17.6186C0.611328 18.1786 1.05133 18.6486 1.61133 18.6486L3.99133 18.6886C3.99133 18.6886 4.00133 18.6886 4.01133 18.6886C4.27133 18.6886 4.53133 18.5886 4.72133 18.3986L15.4913 7.95859C15.6913 7.75859 15.7013 7.43859 15.5013 7.23859L12.4513 4.08859C12.3513 3.98859 12.2213 3.93859 12.0813 3.93859Z" fill="#757676"/>
  <path d="M16.0113 2.01859L17.6813 3.73859L16.5813 4.79859L14.9113 3.07859L16.0113 2.01859ZM16.0213 0.308594C15.7713 0.308594 15.5213 0.398594 15.3213 0.588594L13.1313 2.70859C12.9413 2.88859 12.9313 3.19859 13.1213 3.38859L16.2113 6.57859C16.3013 6.67859 16.4313 6.72859 16.5613 6.72859C16.6913 6.72859 16.8013 6.67859 16.8913 6.58859L19.0813 4.46859C19.4813 4.08859 19.4913 3.44859 19.1013 3.05859L16.7313 0.618594C16.5313 0.418594 16.2713 0.318594 16.0113 0.318594L16.0213 0.308594Z" fill="#757676"/>
</svg>
</span> */}

                                      <span onClick={() => copyClipboard(list?.response !== undefined ? list?.response : list?.message)} > <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M16.669 1.97529C15.5308 0.895193 13.959 0.712594 12.4312 0.676494C11.1871 0.644294 10.3062 0.644294 9.06597 0.676494C7.53717 0.712594 5.96537 0.894294 4.82717 1.97529C4.35597 2.42209 4.06827 2.96359 3.88657 3.53239C2.84447 3.72969 2.01987 4.10879 1.39107 4.70569C0.140572 5.89219 0.104972 7.71939 0.0790718 9.05429L0.0761719 12.4664L0.0790718 12.6139C0.104972 13.9479 0.140572 15.775 1.39107 16.9713C2.57857 18.0983 4.22357 18.2887 5.82267 18.3268C6.47647 18.3434 7.03457 18.3512 7.59217 18.3512C8.14977 18.3512 8.70837 18.3434 9.36027 18.3268C10.9609 18.2887 12.6059 18.0983 13.7934 16.9713C14.4994 16.3019 14.8041 15.4332 14.9481 14.6534C15.5778 14.462 16.1668 14.1668 16.6689 13.69C17.8652 12.5562 17.9008 10.8316 17.9243 9.67539V5.97519C17.9009 4.83459 17.8653 3.11009 16.669 1.97529ZM16.4119 5.56469C15.6554 5.55619 15.1092 5.52419 14.6787 5.40009C13.4585 5.06319 12.5376 3.94009 12.439 2.66379C12.4256 2.50219 12.4333 2.34029 12.4357 2.17869C13.8345 2.21409 14.9171 2.37989 15.6367 3.06319C16.2375 3.63349 16.3718 4.55999 16.4119 5.56469ZM12.7613 15.8835C11.9874 16.6179 10.8282 16.7917 9.32377 16.8269C8.04447 16.8601 7.14257 16.8601 5.85937 16.8269C4.35647 16.7917 3.19727 16.6169 2.42577 15.8855C1.62787 15.1228 1.60207 13.7742 1.57907 12.5857L1.57617 9.23319L1.57907 9.08379C1.60197 7.89529 1.62787 6.54859 2.42327 5.79379C2.73227 5.50079 3.12217 5.29039 3.60487 5.14019C3.58137 5.48959 3.57427 5.82719 3.56827 6.13649L3.56537 9.38159L3.56827 9.52219C3.59267 10.7966 3.62637 12.5427 4.82657 13.6902C5.96477 14.7703 7.53657 14.9529 9.06437 14.989C9.68647 15.0046 10.2172 15.0124 10.748 15.0124C11.2783 15.0124 11.8095 15.0046 12.4296 14.989C12.729 14.9819 13.0296 14.9661 13.3288 14.9421C13.1957 15.3359 13.012 15.6457 12.7613 15.8835ZM15.6368 12.6023C14.9093 13.2927 13.8145 13.4558 12.3931 13.489C11.1763 13.5193 10.3199 13.5193 9.10107 13.489C7.68117 13.4558 6.58647 13.2927 5.86137 12.6042C5.11427 11.8894 5.08987 10.6169 5.06787 9.49379L5.06547 6.30829L5.06787 6.16469C5.08987 5.04259 5.11427 3.77019 5.85987 3.06309C6.58647 2.37269 7.68117 2.20959 9.10257 2.17639C9.71097 2.16079 10.2291 2.15299 10.7481 2.15299C10.8004 2.15299 10.8549 2.15399 10.9073 2.15419C10.9046 2.36559 10.8967 2.57799 10.9141 2.78579C11.063 4.71939 12.4126 6.36199 14.2632 6.87269C14.8599 7.04479 15.5245 7.08409 16.4243 7.09339V9.65979C16.4004 10.8395 16.3219 11.9529 15.6368 12.6023Z" fill="#757676" />
                                      </svg></span>
                                      <span onClick={() => copyForward(list?.response !== undefined ? list?.response : list?.message, list?.messageId,)} > <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M9.05212 3.73359C9.01742 2.89569 8.94472 2.36149 8.80892 1.92989C8.63072 1.38299 8.34652 0.996287 7.93732 0.748287C7.22642 0.320587 6.38412 0.307887 5.62582 0.712187C4.80892 1.15169 3.87972 2.02669 2.43102 3.41729L1.70792 4.11259C0.713822 5.05889 0.165922 5.57939 0.0580223 6.35669C0.0302223 6.55299 0.0302223 6.76199 0.0575223 6.95529C0.166422 7.73949 0.719622 8.27069 1.72402 9.23559L2.47552 9.95729C3.91542 11.3333 4.86712 12.2425 5.70062 12.6497C6.28702 12.9427 6.96432 12.9798 7.55702 12.7503C8.10392 12.5384 8.52092 12.1224 8.73032 11.5804C8.92812 11.0736 9.00812 10.4329 9.04282 9.56579C11.2098 9.69179 12.4774 10.1224 13.0067 10.9066C13.5668 11.7367 13.453 13.1712 12.6586 15.2933C12.5258 15.6478 12.6137 16.0472 12.8827 16.3099C13.0634 16.4876 13.3036 16.5814 13.5492 16.5814C13.6693 16.5814 13.7909 16.5589 13.9076 16.5121C15.8661 15.7221 17.9633 13.0668 17.9633 10.3734C17.9633 4.85579 13.0784 3.87319 9.05212 3.73359ZM14.5423 14.341C15.0408 12.4709 14.9422 11.093 14.2498 10.0676C13.3431 8.72379 11.573 8.11639 8.33132 8.03539H8.31272C8.11932 8.03539 7.93282 8.11059 7.79322 8.24439C7.64872 8.38309 7.56612 8.57349 7.56272 8.77369C7.54662 9.81859 7.50122 10.6028 7.33172 11.0374C7.27412 11.1868 7.16762 11.2923 7.01582 11.3519C6.81802 11.4261 6.57782 11.4115 6.36492 11.305C5.73452 10.9974 4.80242 10.1058 3.46162 8.82449L2.76292 8.15359C2.05102 7.46999 1.58082 7.01879 1.54322 6.74739C1.53492 6.68979 1.53492 6.62529 1.54322 6.56479C1.57932 6.30499 2.04172 5.86559 2.77222 5.17119L3.47042 4.49929C4.79222 3.22979 5.70582 2.37229 6.33472 2.03349C6.62522 1.87729 6.90502 1.87729 7.16142 2.03149C7.19312 2.05099 7.28982 2.10959 7.38022 2.38789C7.51202 2.80589 7.54722 3.52169 7.56382 4.09689L7.56972 4.36639C7.53802 4.60179 7.61952 4.84299 7.79722 5.01189L7.80652 5.02069C7.97502 5.17889 8.20442 5.24919 8.42522 5.21889C14.1327 5.31169 16.4633 6.80969 16.4633 10.3732C16.4633 11.8752 15.5877 13.3976 14.5423 14.341Z" fill="#757676" />
                                      </svg></span>
                                    </div>}
                                </div>
                                {/* <p onClick={() => handleExpand(list)}>{list?.response !== undefined ? parse(list?.response) : list?.message}</p> */}
                                <div className={styles.wordwrapline}>
                                <div onClick={() => handleExpand(list)}
                                  dangerouslySetInnerHTML={{ __html: list?.response !== undefined ? list.response : list?.message }} />
                                </div>
                                <div className={`${styles.likedislikebox} ${styles.likescomment} ${(!list?.AssistMsg?.isLike && !list?.AssistMsg?.isDislike) ? styles.likedislikeboxonhover : ''}`}
                                // style={{ display: (list?.AssistMsg?.isLike || list?.AssistMsg?.isdisLike) ? "flex" : 'none' } }
                                >

                                  <div className={styles.like}
                                    onClick={() => handleLike(list)}
                                  >
                                    {list?.AssistMsg?.isLike == 1 ?

                                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_5962_24523)">
                                          <path fill-rule="evenodd" clip-rule="evenodd" d="M14 7.2499C14 6.61283 13.4788 6.09163 12.8417 6.09163H9.68853C9.53413 6.09163 9.44047 5.92763 9.51213 5.7909C9.9444 4.96603 10.1667 4.11743 10.1667 3.78997C10.1667 3.22983 9.7204 2.63477 8.98527 2.63477C7.4712 2.63477 8.35513 4.4551 6.39473 6.0217L6.00093 6.33677C5.72087 6.5643 5.57207 6.8969 5.57207 7.22943V10.5912C5.57207 11.251 5.88213 11.8724 6.40927 12.2692L6.84107 12.5942C7.5062 13.0931 8.31133 13.3644 9.134 13.3644H10.5343C11.1731 13.3644 11.6808 12.848 11.6808 12.2179C11.6808 12.1304 11.672 12.0429 11.6545 11.9641C12.1183 11.8154 12.4509 11.3865 12.4509 10.8789C12.4509 10.66 12.3897 10.4588 12.2759 10.2838C12.8097 10.1875 13.2123 9.7149 13.2123 9.15477C13.2123 8.85723 13.0985 8.5859 12.906 8.38463C13.5011 8.3409 14 7.85377 14 7.2499ZM3.753 13.3643H3.04733C2.46893 13.3643 2 12.8954 2 12.317V7.41077C2 6.83237 2.46893 6.36343 3.04733 6.36343H3.753C4.3314 6.36343 4.80033 6.83237 4.80033 7.41077V12.317C4.80033 12.8954 4.3314 13.3643 3.753 13.3643Z" fill="#757676" />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_5962_24523">
                                            <rect width="16" height="16" fill="white" />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                      :
                                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M6.9852 1.6349C7.15893 1.6349 7.16673 1.78383 7.16673 1.78383C7.1594 1.94837 6.99367 2.62597 6.6262 3.3271C6.42793 3.7055 6.4412 4.14903 6.66173 4.51343C6.8808 4.87557 7.2646 5.0917 7.6884 5.0917H10.8417C10.926 5.0917 10.9999 5.16576 10.9999 5.25003C10.9999 5.31316 10.9172 5.38103 10.8329 5.38723C10.4467 5.41557 10.1117 5.66423 9.9726 6.02557C9.8336 6.3869 9.91567 6.7959 10.1832 7.07583C10.2027 7.09617 10.2123 7.12203 10.2123 7.15477C10.2123 7.23256 10.1543 7.2895 10.0982 7.29977C9.7686 7.35916 9.49067 7.5797 9.35787 7.88717C9.22507 8.19463 9.25493 8.54816 9.43747 8.8289C9.4462 8.84223 9.45087 8.8543 9.45087 8.8789C9.45087 8.95297 9.396 8.9969 9.34907 9.01203C8.865 9.16716 8.57873 9.68096 8.67793 10.1795C8.67873 10.1834 8.68073 10.1977 8.68073 10.2179C8.68073 10.3001 8.61647 10.3644 8.53433 10.3644H7.13393C6.53247 10.3644 5.93127 10.1619 5.44247 9.79517L5.01067 9.47017C4.736 9.26343 4.572 8.93483 4.572 8.59123V5.22943C4.572 5.2135 4.57633 5.15763 4.6256 5.11743L5.01893 4.80283C6.22113 3.84203 6.56973 2.7781 6.80033 2.07417C6.84827 1.92783 6.91047 1.73803 6.9586 1.63523C6.9666 1.6349 6.9754 1.6349 6.9852 1.6349ZM6.98513 0.634766C5.47113 0.634766 6.355 2.4551 4.39467 4.02163L4.00087 4.33677C3.72073 4.5643 3.572 4.89683 3.572 5.2295V8.5913C3.572 9.25096 3.88207 9.87236 4.40927 10.2692L4.84107 10.5942C5.5062 11.093 6.31133 11.3644 7.13393 11.3644H8.53433C9.17307 11.3644 9.68073 10.8479 9.68073 10.2179C9.68073 10.1304 9.67193 10.0429 9.65453 9.96416C10.1183 9.81543 10.4509 9.3865 10.4509 8.8789C10.4509 8.66017 10.3897 8.45883 10.2759 8.28383C10.8097 8.1875 11.2123 7.71496 11.2123 7.15477C11.2123 6.85723 11.0985 6.5859 10.906 6.38456C11.5011 6.34096 12 5.85383 12 5.24997C12 4.6129 11.4787 4.09163 10.8417 4.09163H7.68847C7.53407 4.09163 7.4404 3.92777 7.51207 3.79103C7.94433 2.96603 8.16667 2.1175 8.16667 1.79003C8.16667 1.22983 7.7202 0.634766 6.98513 0.634766Z" fill="#757676" />
                                        <path d="M1.753 4.36376H1.04733C0.468907 4.36376 0 4.83267 0 5.4111V10.3173C0 10.8957 0.468907 11.3646 1.04733 11.3646H1.753C2.33143 11.3646 2.80033 10.8957 2.80033 10.3173V5.4111C2.80033 4.83267 2.33143 4.36376 1.753 4.36376Z" fill="#757676" />
                                      </svg>}
                                  </div>
                                  <div className={styles.dislike}
                                    onClick={() => handledisLike(list)}
                                  >
                                    {
                                      list?.AssistMsg?.isDislike == 1 ?
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.59073 3.7299L9.15893 3.4049C8.49373 2.90603 7.68853 2.63477 6.86593 2.63477H5.46553C4.82667 2.63477 4.31907 3.1511 4.31907 3.78123C4.31907 3.86877 4.32787 3.95623 4.34527 4.03503C3.88153 4.18377 3.54907 4.61263 3.54907 5.12017C3.54907 5.33903 3.61027 5.5403 3.72407 5.7153C3.1902 5.81157 2.78773 6.28417 2.78773 6.8443C2.78773 7.1419 2.90153 7.41317 3.09407 7.6145C2.49887 7.65823 2 8.1453 2 8.74917C2 9.38623 2.52113 9.9075 3.15833 9.90743H6.31147C6.46573 9.90743 6.55953 10.0714 6.48787 10.2082C6.0556 11.0331 5.83327 11.8817 5.83327 12.2092C5.83327 12.7693 6.27953 13.3644 7.01473 13.3644C8.52873 13.3644 7.6448 11.544 9.6052 9.97743L9.99907 9.66237C10.279 9.43483 10.4279 9.1023 10.4279 8.7697V5.4079C10.4279 4.7481 10.1178 4.1267 9.59073 3.7299Z" fill="#757676" />
                                          <path d="M12.9527 3.20163H12.2471C11.6687 3.20163 11.1998 3.67054 11.1998 4.24897V9.15517C11.1998 9.73359 11.6687 10.2025 12.2471 10.2025H12.9527C13.5312 10.2025 14.0001 9.73359 14.0001 9.15517V4.24897C14.0001 3.67054 13.5312 3.20163 12.9527 3.20163Z" fill="#757676" />
                                        </svg>
                                        :
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.59067 1.7299L7.15887 1.4049C6.4938 0.906032 5.68867 0.634766 4.86607 0.634766H3.46567C2.8268 0.634766 2.3192 1.15117 2.3192 1.78123C2.3192 1.86877 2.328 1.95623 2.3454 2.03503C1.88167 2.18377 1.549 2.61263 1.549 3.12017C1.549 3.33903 1.61033 3.5403 1.72413 3.7153C1.19027 3.81157 0.7876 4.28417 0.7876 4.8443C0.7876 5.1419 0.9014 5.41317 1.09393 5.6145C0.498867 5.65823 0 6.1453 0 6.74917C0 7.38623 0.521133 7.9075 1.1582 7.9075H4.31153C4.4658 7.9075 4.5596 8.0715 4.48793 8.20823C4.05567 9.0331 3.83333 9.8817 3.83333 10.2092C3.83333 10.7693 4.2796 11.3644 5.0148 11.3644C6.5288 11.3644 5.64487 9.54403 7.60527 7.97743L7.999 7.66237C8.27913 7.43483 8.42787 7.1023 8.42787 6.7697V3.4079C8.42787 2.7481 8.11787 2.1267 7.59067 1.7299ZM7.42793 6.76977C7.42793 6.78577 7.42373 6.8415 7.3742 6.88163L6.98113 7.19623C5.77867 8.15703 5.4302 9.22097 5.19953 9.92497C5.15167 10.0712 5.08953 10.2611 5.04133 10.3639C5.03333 10.3642 5.0246 10.3643 5.0148 10.3643C4.841 10.3643 4.83313 10.2154 4.83313 10.2154C4.84047 10.0508 5.00633 9.37323 5.3738 8.67203C5.57207 8.29357 5.55867 7.85003 5.33813 7.48557C5.11887 7.12343 4.73513 6.9073 4.31147 6.9073H1.15813C1.0738 6.9073 0.999933 6.83337 0.999933 6.74903C0.999933 6.6859 1.0828 6.6179 1.16727 6.6117C1.55333 6.5833 1.88827 6.33463 2.02727 5.9733C2.16613 5.61197 2.08407 5.2029 1.81647 4.92317C1.79693 4.90283 1.78747 4.87697 1.78747 4.84423C1.78747 4.76643 1.8454 4.7095 1.9014 4.69937C2.231 4.6399 2.509 4.41943 2.64193 4.11203C2.77473 3.80457 2.74493 3.45103 2.56233 3.17023C2.55353 3.1567 2.5488 3.14477 2.5488 3.12017C2.5488 3.04617 2.60367 3.0023 2.65067 2.98723C3.13487 2.8319 3.42133 2.3185 3.32173 1.81977C3.32093 1.8159 3.31893 1.80143 3.31893 1.78117C3.31893 1.69903 3.3832 1.6347 3.4654 1.6347H4.8658C5.46733 1.6347 6.06847 1.83717 6.5572 2.20377L6.989 2.52883C7.26373 2.73557 7.42767 3.06417 7.42767 3.40783L7.42793 6.76977Z" fill="#757676" />
                                          <path d="M10.9529 1.20163H10.2473C9.66884 1.20163 9.19994 1.67054 9.19994 2.24897V7.15517C9.19994 7.73359 9.66884 8.2025 10.2473 8.2025H10.9529C11.5313 8.2025 12.0002 7.73359 12.0002 7.15517V2.24897C12.0002 1.67054 11.5313 1.20163 10.9529 1.20163Z" fill="#757676" />
                                        </svg>
                                    }
                                  </div>
                                </div>
                              </div>
                            </>
                          )
                        }
                      })}

                      {currentAgentAssist?.length > 0 && currentAgentAssist.map((list: any) => {
                        if (list?.sessionId === currentSession?.sessionId) {
                          return (
                            <>
                              <div className={`${styles.bundleenquiry} ${styles.bundleenquiryarea}`} ref={messagesEndRef_agentAssist}>
                                <div className={styles.headerArea}>
                                  <div className={styles.cardDt}>
                                    {/* <span className={styles.title}>{list?.intent}</span> */}
                                    <span className={styles.subText}>Reason • {moment(list?.timeStamp).format("hh:mm a")}</span>
                                  </div>
                                  {currentSession?.channeltype != "Call" &&
                                    <div className={`${styles.cardAction} ${styles.cardActionlistmodule}`}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none" onClick={() => copyClipboard(list?.message)}>
                                        <path d="M16.7276 1.64619C15.5894 0.566092 14.0176 0.383492 12.4898 0.347392C11.2457 0.315192 10.3648 0.315192 9.12457 0.347392C7.59577 0.383492 6.02397 0.565192 4.88577 1.64619C4.41457 2.09299 4.12687 2.63449 3.94517 3.20329C2.90307 3.40059 2.07847 3.77969 1.44967 4.37659C0.199166 5.56309 0.163566 7.39029 0.137666 8.72519L0.134766 12.1373L0.137666 12.2848C0.163566 13.6188 0.199166 15.4459 1.44967 16.6422C2.63717 17.7692 4.28217 17.9596 5.88127 17.9977C6.53507 18.0143 7.09317 18.0221 7.65077 18.0221C8.20837 18.0221 8.76696 18.0143 9.41887 17.9977C11.0195 17.9596 12.6645 17.7692 13.852 16.6422C14.558 15.9728 14.8627 15.1041 15.0067 14.3243C15.6364 14.1329 16.2254 13.8377 16.7275 13.3609C17.9238 12.2271 17.9594 10.5025 17.9829 9.34629V5.64609C17.9595 4.50549 17.9239 2.78099 16.7276 1.64619ZM16.4705 5.23559C15.714 5.22709 15.1678 5.19509 14.7373 5.07099C13.5171 4.73409 12.5962 3.61099 12.4976 2.33469C12.4842 2.17309 12.4919 2.01119 12.4943 1.84959C13.8931 1.88499 14.9757 2.05079 15.6953 2.73409C16.2961 3.30439 16.4304 4.23089 16.4705 5.23559ZM12.8199 15.5544C12.046 16.2888 10.8868 16.4626 9.38237 16.4978C8.10307 16.531 7.20117 16.531 5.91797 16.4978C4.41507 16.4626 3.25587 16.2878 2.48437 15.5564C1.68647 14.7937 1.66067 13.4451 1.63767 12.2566L1.63477 8.90409L1.63767 8.75469C1.66057 7.56619 1.68647 6.21949 2.48187 5.46469C2.79087 5.17169 3.18077 4.96129 3.66347 4.81109C3.63997 5.16049 3.63287 5.49809 3.62687 5.80739L3.62397 9.05249L3.62687 9.19309C3.65127 10.4675 3.68497 12.2136 4.88517 13.3611C6.02337 14.4412 7.59517 14.6238 9.12297 14.6599C9.74507 14.6755 10.2758 14.6833 10.8066 14.6833C11.3369 14.6833 11.8681 14.6755 12.4882 14.6599C12.7876 14.6528 13.0882 14.637 13.3874 14.613C13.2543 15.0068 13.0706 15.3166 12.8199 15.5544ZM15.6954 12.2732C14.9679 12.9636 13.8731 13.1267 12.4517 13.1599C11.2349 13.1902 10.3785 13.1902 9.15967 13.1599C7.73977 13.1267 6.64507 12.9636 5.91997 12.2751C5.17287 11.5603 5.14847 10.2878 5.12647 9.16469L5.12407 5.97919L5.12647 5.83559C5.14847 4.71349 5.17287 3.44109 5.91847 2.73399C6.64507 2.04359 7.73977 1.88049 9.16117 1.84729C9.76957 1.83169 10.2877 1.82389 10.8067 1.82389C10.859 1.82389 10.9135 1.82489 10.9659 1.82509C10.9632 2.03649 10.9553 2.24889 10.9727 2.45669C11.1216 4.39029 12.4712 6.03289 14.3218 6.54359C14.9185 6.71569 15.5831 6.75499 16.4829 6.76429V9.33069C16.459 10.5104 16.3805 11.6238 15.6954 12.2732Z" fill="#757676" />
                                      </svg>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none" onClick={() => copyForward(list?.message, list?.messageId ? list?.messageId : null)}>
                                        <path d="M9.11072 3.40693C9.07602 2.56903 9.00332 2.03483 8.86752 1.60323C8.68932 1.05633 8.40512 0.669627 7.99592 0.421627C7.28502 -0.00607312 6.44272 -0.018773 5.68442 0.385527C4.86752 0.825027 3.93832 1.70003 2.48962 3.09063L1.76652 3.78593C0.772416 4.73223 0.224516 5.25273 0.116616 6.03003C0.088816 6.22633 0.0888161 6.43533 0.116116 6.62863C0.225016 7.41283 0.778216 7.94403 1.78262 8.90893L2.53412 9.63063C3.97402 11.0066 4.92572 11.9158 5.75922 12.323C6.34562 12.616 7.02292 12.6531 7.61562 12.4236C8.16252 12.2117 8.57952 11.7957 8.78892 11.2537C8.98672 10.7469 9.06672 10.1062 9.10142 9.23913C11.2684 9.36513 12.536 9.79573 13.0653 10.5799C13.6254 11.41 13.5116 12.8445 12.7172 14.9666C12.5844 15.3211 12.6723 15.7205 12.9413 15.9832C13.122 16.1609 13.3622 16.2547 13.6078 16.2547C13.7279 16.2547 13.8495 16.2322 13.9662 16.1854C15.9247 15.3954 18.0219 12.7401 18.0219 10.0467C18.0219 4.52913 13.137 3.54653 9.11072 3.40693ZM14.6009 14.0143C15.0994 12.1442 15.0008 10.7663 14.3084 9.74093C13.4017 8.39713 11.6316 7.78973 8.38992 7.70873H8.37132C8.17792 7.70873 7.99142 7.78393 7.85182 7.91773C7.70732 8.05643 7.62472 8.24683 7.62132 8.44703C7.60522 9.49193 7.55982 10.2761 7.39032 10.7107C7.33272 10.8601 7.22622 10.9656 7.07442 11.0252C6.87662 11.0994 6.63642 11.0848 6.42352 10.9783C5.79312 10.6707 4.86102 9.77913 3.52022 8.49783L2.82152 7.82693C2.10962 7.14333 1.63942 6.69213 1.60182 6.42073C1.59352 6.36313 1.59352 6.29863 1.60182 6.23813C1.63792 5.97833 2.10032 5.53893 2.83082 4.84453L3.52902 4.17263C4.85082 2.90313 5.76442 2.04563 6.39332 1.70683C6.68382 1.55063 6.96362 1.55063 7.22002 1.70483C7.25172 1.72433 7.34842 1.78293 7.43882 2.06123C7.57062 2.47923 7.60582 3.19503 7.62242 3.77023L7.62832 4.03973C7.59662 4.27513 7.67812 4.51633 7.85582 4.68523L7.86512 4.69403C8.03362 4.85223 8.26302 4.92253 8.48382 4.89223C14.1913 4.98503 16.5219 6.48303 16.5219 10.0465C16.5219 11.5485 15.6463 13.0709 14.6009 14.0143Z" fill="#757676" />
                                      </svg>
                                      {/* <span className="icon__Copy24" onClick={() => copyClipboard(list?.message)} ></span>
                                <span className="icon__Forward24" onClick={() => copyForward(list?.message)} ></span> */}
                                    </div>}
                                </div>
                                <p onClick={() => handleExpand({ ...list, response: list.message })}>{list?.message}</p>
                              </div>
                            </>
                          )
                        }
                      })}


                    </> : <>
                      <div className={`${styles.assitTemplateheight} ${styles.assitTemplate}`}>
                        <div className={styles.assitTemplate}>
                          <div className={styles.headerArea}>
                            <div className={`${styles.headercardbtn} ${styles.headercardbtnreason}`}>
                              <div className={styles.backBtn}>
                                <span className="icon__goBack24" onClick={goBack}></span>
                              </div>
                              <div className={styles.cardDt}>
                                <span className={styles.title}>{expandData?.emotion} </span>
                                <span className={styles.subText}>Reason •{moment(expandData?.timeStamp).format("hh:mm a")}</span>
                              </div>
                            </div>
                            {currentSession?.channeltype != "Call" &&
                              <div className={styles.cardAction}>
                                <span className="icon__Copy24" onClick={() => copyClipboard(expandData?.response ? expandData?.response : expandData?.message, 'copyText_main')}></span>
                              </div>}
                          </div>
                          <div className={styles.assignTemplateText}>
                            {/* <p id="copyText_main">{expandData?.response ? parse(expandData?.response) : expandData?.message}</p> */}
                            <div id="copyText_main" dangerouslySetInnerHTML={{ __html: expandData?.response ? expandData.response : expandData?.message }} />
                          </div>
                        </div>
                        {currentSession?.channeltype != "Call" &&
                          <div className={styles.useBtn}>
                            <WtButton className="buttonCancel" name="Use this" onClick={() => { copyForward(expandData?.response ? expandData?.response : expandData?.message, expandData?.messageId ?? null); goBack(); }} />
                          </div>
                        }
                      </div>
                    </>}




                  </div>
                  {!isAssExpand &&
                    <div className={styles.typequestion}>
                      <textarea ref={agentAssistTextareaRef} onKeyDown={enterButton} placeholder="Type your question..." rows={1} value={agentQueryText} onChange={(e: any) => setAgentQueryText(e.target.value)} />
                      <img className={styles.sendicon} src={sendicon} alt="sendicon" onClick={handleAgentQueryAssist} />
                    </div>
                  }
                </div>}

            </TabPane>
            {!(currentSession?.callBack === 1 || currentSession?.CallBackStatus == 1) && 
            <TabPane tab={<span className={!hassAccess('workspace/internalChat') ? styles.chatgre : ''}>{'Internal Chat'}</span>} key="cochat">
              {!hassAccess('workspace/internalChat') 
              ? <div className={styles.centerupgrade}>
                <div  className={`${styles.svgscrollert} `}>
                 {/* <div onClick={() => openUpgade('Agent Assist')} className={`${styles.svgscrollert} blurchat`}> */}
                  <div className={`${styles.agentassistu} blurchat`}>
                    <div className={styles.svgscrollertassist}>
                      <img src={Locts} />
                    </div>
                    <div className={styles.svgscrollertassist}>
                      <img src={Loctsts} />
                    </div>
                  </div>
                  <div className={`${styles.svgscrollertassistline} blurchat`}>
                    <img src={Loctstsfirst} />
                  </div>
                </div>
                 <div className={styles.upgradeline}>
                 <div className={styles.upgradetst}>Upgrade plan to view internal Chat...</div>
                 <div className={styles.pasword}><img src={Upgradepass} alt="" />
                 {/* <button onClick={open}>Upgrade</button> */}
                 </div>
                </div>
                </div> 
                : <InternalChat /> }
              
            </TabPane>}
            {!(isTrackAgent || isTrackerAgentChat) && <TabPane tab={<span className={!hassAccess('workspace/notes') ? styles.chatgre : ''}>{'Notes'}</span>} key="Notes">
              {!hassAccess('workspace/notes') 
              ? <div className={styles.centerupgrade}>
                <div  className={`${styles.svgscrollert} `}>
                 {/* <div onClick={() => openUpgade('Agent Assist')} className={`${styles.svgscrollert} blurchat`}> */}
                  <div className={`${styles.agentassistu} blurchat`}>
                    <div className={styles.svgscrollertassist}>
                      <img src={Locts} />
                    </div>
                    <div className={styles.svgscrollertassist}>
                      <img src={Loctsts} />
                    </div>
                  </div>
                  <div className={`${styles.svgscrollertassistline} blurchat`}>
                    <img src={Loctstsfirst} />
                  </div>
                </div>
                 <div className={styles.upgradeline}>
                 <div className={styles.upgradetst}>Upgrade plan to view Note...</div>
                 <div className={styles.pasword}><img src={Upgradepass} alt="" />
                 {/* <button onClick={open}>Upgrade</button> */}
                 </div>
                </div>
                </div> :
              <div className={`${styles.notesbody} ${styles.scrollernotest}`}>
                <div className={`${styles.scroller}  ${styles.scrollernew} ${isTrackAgent ? "noteswhenwhisscroll" : ""}`} style={containerStyle} ref={divRef}>
                  {/* Ensure notes is an array before checking length */}
                  {Array.isArray(notes) && notes.length > 0 ? (
                    notes
                      .filter(note => note.message && note.timestamp) // Filter out messages with undefined timestamp or message
                      .map((note, index) => (
                        <div key={index} className={styles.notescard}>
                          <div className={styles.cont}>
                            <div dangerouslySetInnerHTML={{ __html: note.message }} />
                          </div>
                          <div className={styles.info}>
                            <p>
                              <span>Me</span> <span>-</span>
                              {/* Show timestamp if available */}
                              {note.timestamp ? new Date(note.timestamp).toLocaleString() : 'No timestamp available'}
                            </p>

                            <span className={styles.hoveredicons}>

                              <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 20" fill="none" onClick={() => handleEditNote(note)}>
                                  <path d="M12.319 6.34859L13.989 8.06859L4.06896 17.6786L2.36896 17.6486L2.39896 15.9486L12.319 6.33859M12.339 4.43859C12.209 4.43859 12.079 4.48859 11.989 4.57859L1.21896 15.0186C1.02896 15.2086 0.908958 15.4686 0.908958 15.7386L0.868958 18.1186C0.868958 18.6786 1.30896 19.1486 1.86896 19.1486L4.24896 19.1886C4.24896 19.1886 4.25896 19.1886 4.26896 19.1886C4.52896 19.1886 4.78896 19.0886 4.97896 18.8986L15.749 8.45859C15.949 8.25859 15.959 7.93859 15.759 7.73859L12.709 4.58859C12.609 4.48859 12.479 4.43859 12.339 4.43859Z" fill="#757676" />
                                  <path d="M16.269 2.51859L17.939 4.23859L16.839 5.29859L15.169 3.57859L16.269 2.51859ZM16.279 0.808594C16.029 0.808594 15.779 0.898594 15.579 1.08859L13.389 3.20859C13.199 3.38859 13.189 3.69859 13.379 3.88859L16.469 7.07859C16.559 7.17859 16.689 7.22859 16.819 7.22859C16.949 7.22859 17.059 7.17859 17.149 7.08859L19.339 4.96859C19.739 4.58859 19.749 3.94859 19.359 3.55859L16.989 1.11859C16.789 0.918594 16.529 0.818594 16.269 0.818594L16.279 0.808594Z" fill="#757676" />
                                </svg>
                              </span>
                              <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 19 22" fill="none" onClick={() => handleDeleteNote(note.noteId)}>
                                  <path d="M7.63709 16.9331C7.22299 16.9331 6.88709 16.5972 6.88709 16.1831V7.61329C6.88709 7.19919 7.22299 6.86329 7.63709 6.86329C8.05119 6.86329 8.38709 7.19919 8.38709 7.61329V16.1831C8.38709 16.5972 8.05119 16.9331 7.63709 16.9331Z" fill="#757676" />
                                  <path d="M10.8773 16.9331C10.4632 16.9331 10.1273 16.5972 10.1273 16.1831V7.61329C10.1273 7.19919 10.4632 6.86329 10.8773 6.86329C11.2914 6.86329 11.6273 7.19919 11.6273 7.61329V16.1831C11.6273 16.5972 11.2914 16.9331 10.8773 16.9331Z" fill="#757676" />
                                  <path d="M17.4271 3.46339H13.4769V2.85349C13.4769 1.79489 12.6429 0.933594 11.6175 0.933594H6.88699C5.86159 0.933594 5.02709 1.79489 5.02709 2.85349V3.46339H1.08719C0.673089 3.46339 0.337189 3.79929 0.337189 4.21339C0.337189 4.62749 0.673089 4.96339 1.08719 4.96339H1.69149L2.45879 17.607C2.57109 19.5455 4.18239 21.064 6.12729 21.064H12.3675C14.3109 21.064 15.931 19.5435 16.056 17.5992L16.8238 4.96349H17.4271C17.8412 4.96349 18.1771 4.62759 18.1771 4.21349C18.1771 3.79939 17.8412 3.46339 17.4271 3.46339ZM6.52719 2.85349C6.52719 2.62209 6.68879 2.43359 6.88709 2.43359H11.6176C11.8158 2.43359 11.977 2.62209 11.977 2.85349V3.46339H6.52729L6.52719 2.85349ZM14.5589 17.5054C14.4847 18.6597 13.5218 19.564 12.3675 19.564H6.12729C4.97639 19.564 4.02229 18.6665 3.95589 17.5181L3.19409 4.96339H15.3202L14.5589 17.5054Z" fill="#757676" />
                                </svg>
                              </span>
                            </span>
                          </div>
                        </div>
                      ))
                  ) : (
                    <div className={styles.emptypage}>

                      <div className={styles.emptynotesimgcon}>
                        <div className={styles.imgcon}>
                          <img src={notesemptyimg} alt="no data" /></div>
                        <span>No notes yet!!</span>
                      </div>

                    </div>

                    // <p>No messages available.</p> // Optional: display a message when there are no notes
                  )}
                </div>

                <div className={`${styles.footer} ${isExpanded ? styles.expanded : ""} ${isTrackAgent ? "noteswhenwhisper" : ""}`} ref={divRef}>
                  {
                    !isExpanded ?
                      <WtButton name="Add" className="buttonGreenCreate" onClick={handleAddClick} /> :
                      <div className={styles.expandedblock}>
                        <div className={styles.ashdash}></div>
                        <div style={{ display: "flex", justifyContent: "end", margin: "12px 0px 12px 0" }} >

                          {/* <svg style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" onClick={handleAddClick} >
                            <path d="M7.70667 7.00009L9.92061 4.78615C10.1159 4.5909 10.1159 4.27463 9.92061 4.07944C9.72536 3.88426 9.40909 3.88419 9.21391 4.07944L6.99996 6.29339L4.78602 4.07944C4.59076 3.88419 4.2745 3.88419 4.07931 4.07944C3.88413 4.2747 3.88406 4.59096 4.07931 4.78615L6.29326 7.00009L4.07931 9.21404C3.88406 9.40929 3.88406 9.72556 4.07931 9.92074C4.17694 10.0184 4.30482 10.0672 4.4327 10.0672C4.56058 10.0672 4.68846 10.0184 4.78608 9.92074L7.00003 7.7068L9.21397 9.92074C9.3116 10.0184 9.43948 10.0672 9.56736 10.0672C9.69524 10.0672 9.82312 10.0184 9.92074 9.92074C10.116 9.72549 10.116 9.40922 9.92074 9.21404L7.70667 7.00009Z" fill="#505152" />
                            <path d="M6.99983 1.33552C10.1231 1.33552 12.6641 3.87653 12.6641 6.99983C12.6641 10.1231 10. 1231 12.6641 6.99983 12.6641C3.87653 12.6641 1.33552 10.1231 1.33552 6.99983C1.33552 3.87653 3.8766 1.33552 6.99983 1.33552ZM6.99983 0.335938C3.31943 0.335938 0.335938 3.31949 0.335938 6.99983C0.335938 10.6802 3.31943 13.6637 6.99983 13.6637C10.6802 13.6637 13.6637 10.6802 13.6637 6.99983C13.6637 3.31949 10.6802 0.335938 6.99983 0.335938Z" fill="#505152" />
                          </svg> */}
                          <span className={styles.handleclicktst}>
                          <svg style={{ cursor: "pointer" }} onClick={handleAddClick} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16" fill="none">
                            <path d="M14.2095 1.2959C14.3269 1.17784 14.5117 1.16188 14.6479 1.25195L14.7026 1.29688L14.7036 1.29785C14.8224 1.41675 14.8371 1.60126 14.7476 1.73633L14.7036 1.79004L8.84717 7.64648L8.49463 8L8.84717 8.35352L14.7036 14.21C14.8224 14.3288 14.837 14.5134 14.7476 14.6484L14.7036 14.7031H14.7026C14.6339 14.7719 14.5458 14.8057 14.4556 14.8057C14.3871 14.8057 14.3204 14.7862 14.2632 14.748L14.2095 14.7041L14.2085 14.7031L8.354 8.84766L8.00049 8.49414L7.646 8.84766L1.7915 14.7031L1.79053 14.7041C1.72362 14.7714 1.63545 14.8057 1.54443 14.8057C1.47669 14.8057 1.41012 14.7867 1.35205 14.748L1.29736 14.7031L1.25244 14.6484C1.17573 14.5326 1.17598 14.3806 1.25244 14.2646L1.29736 14.21V14.209L7.50635 8L1.29736 1.79102V1.79004L1.25244 1.73633C1.17555 1.62026 1.17556 1.46763 1.25244 1.35156L1.29736 1.29785L1.29834 1.2959C1.41599 1.17757 1.60121 1.16247 1.73584 1.25098L1.79053 1.2959L1.7915 1.29688L7.646 7.15234L8.00049 7.50586L8.354 7.15234L14.2085 1.29688L14.2095 1.2959Z" fill="#F5F6F7" stroke="#828385" />
                          </svg>
                         </span>
                        </div >
                        <Editornotes editingMessageId={editingMessageId} setEditingMessageId={(value: any) => setEditingMessageId(value)} editorContentmsg={editorContentmsg} onEditorChange={(value: any) => setEditorContentmsg(value)}
                        />
                      </div>
                  }
                </div>
              </div>}
            </TabPane>}
          </Tabs>

        </div>

        {/* Internal chat */}
        {(isExpand && isAssExpand && isTab !== 'cochat') ? <>
          <div className={styles.btmArea}>
            <div className={styles.btn} onClick={() => getAgentAssitData("Regenerate")}><span>Regenerate</span></div>
            <Tooltip placement="top" overlayClassName="customtooltipmediuem" title="Expand"><span className="icon__Expand28 icnOptn" onClick={() => getAgentAssitData("Expand")}></span></Tooltip>
            <Tooltip placement="top" overlayClassName="customtooltipmediuem" title="Formal"><span className="icon__Formal28 icnOptn" onClick={() => getAgentAssitData("Formal")}></span></Tooltip>
            <Tooltip placement="top" overlayClassName="customtooltipmediuem" title="Friendly"><span className="icon__Friendly28 icnOptn" onClick={() => getAgentAssitData("Friendly")}></span></Tooltip>
          </div>
        </> :

          ''}
      </div>

      <Modal
        title={
          <p className={styles.disposition}>
            Disposition Status <span>00:58</span>
          </p>
        }
        // open={()=>dispatch(internalChatActions.showModal)}
        onOk={() => dispatch(internalChatActions.handleOk)}
        onCancel={() => dispatch(internalChatActions.handleCancel)}
        className="customModal sizeMD"
        closeIcon={<span className="icon_close"></span>}
        footer={[
          <Button key="back" onClick={() => dispatch(internalChatActions.handleCancel)} className="btnWhite">
            Cancel
          </Button>,
          <Button key="submit" type="primary" className="btnGrey">
            Close
          </Button>,
        ]}
      >
        <div className={styles.dispositionform}>
          <label>Disposition</label>
          <Select className={`${styles.editorselectdropdown} antSelect`} placeholder="Reply Via">
            <Option value="premiumcustomer">Premium Customer</Option>
            <Option value="vipcustomer">VIP Customer</Option>
          </Select>
        </div>

        <div className={styles.dispositionform}>
          <label>Summary</label>
          <Select className={`${styles.editorselectdropdown} antSelect`} placeholder="Reply Via">
            <Option value="premiumcustomer">Premium Customer</Option>
            <Option value="vipcustomer">VIP Customer</Option>
          </Select>
        </div>
      </Modal>

    </>
  );
};
export default ChatRightSideBar;
